import { render } from "./ListProduto.vue?vue&type=template&id=73dbf4b9"
import script from "./ListProduto.vue?vue&type=script&lang=js"
export * from "./ListProduto.vue?vue&type=script&lang=js"

import "./ListProduto.vue?vue&type=style&index=0&id=73dbf4b9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__